module.exports = __webpack_public_path__ + "img/gjjh1.44445db7.jpg";